const Index = () => import('@/views/machine/Index')
export default [{
  path: '/machine',
  meta: {
    title: '机械管理',
    activeMenu: '/home/board'
  },
  components: {
    right: Index
  }
}]
